/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventContentDto } from './EventContentDto';
import {
    EventContentDtoFromJSON,
    EventContentDtoFromJSONTyped,
    EventContentDtoToJSON,
    EventContentDtoToJSONTyped,
} from './EventContentDto';

/**
 * 
 * @export
 * @interface EventDto
 */
export interface EventDto {
    /**
     * 
     * @type {string}
     * @memberof EventDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EventDto
     */
    type?: string;
    /**
     * 
     * @type {Array<EventContentDto>}
     * @memberof EventDto
     */
    content?: Array<EventContentDto>;
    /**
     * 
     * @type {string}
     * @memberof EventDto
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof EventDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof EventDto
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the EventDto interface.
 */
export function instanceOfEventDto(value: object): value is EventDto {
    return true;
}

export function EventDtoFromJSON(json: any): EventDto {
    return EventDtoFromJSONTyped(json, false);
}

export function EventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(EventContentDtoFromJSON)),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
    };
}

export function EventDtoToJSON(json: any): EventDto {
    return EventDtoToJSONTyped(json, false);
}

export function EventDtoToJSONTyped(value?: EventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(EventContentDtoToJSON)),
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'tenantId': value['tenantId'],
    };
}

